<template>
  <div class="our-work">
    <Header :imgUrl="require('@/assets/img/mission/03-sm.jpg')">
      <h1>¿Qué hacemos?</h1>
      <a
        class="primary-btn animated fadeIn delay-1s"
        href="#"
        v-scroll-to="{ el: '#content', offset: -90 }"
        >Ver Detalle</a
      >
    </Header>

    <div class="our-work__content" id="content">
      
      <section class="flex gap-2">
        <img class="our-work__text-image" :src="require('@/assets/img/que-hacemos.png')" />

        <section class="flex direction-column gap-2">
          <h2 class="our-work__headline full-width">¿Qué hacemos?</h2>
          <p class="our-work__text-content">
            Nuestro objetivo es fomentar el desarrollo socioeconómico regional sostenible a través de la gestión de proyectos o programas que promuevan el desarrollo humano y crecimiento personal de las familias colombianas, refugiados y/o migrantes, reconociendo la singularidad de cada individuo. 
            Esto se logra mediante el uso del arte, la cultura y la protección del medio ambiente, con un equipo humano cohesionado que busca el crecimiento de familias saludables, cultas, visionarias y productivas a través de proyectos.
          </p>
        </section>
      </section>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";

export default {
  name: "OurWork",

  components: {
    Header
  },

  title() {
    return '¿Qué hacemos?';
  },
};
</script>

<style lang="scss" scoped>
.our-work {
  $root: &;

  &__content {
    width: 100%;
    max-width: 1024px;
    padding: 2rem 1rem;
    margin: 4rem auto;
    position: relative;
  }

  &__headline {
    padding: 0;
    font-size: 2.5rem;
  }

  &__text-content {
    line-height: 1.8;

    span {
      display: block;
      margin: 2rem 0;
    }
  }

  @media(max-width: 1024px) {
    #{$root}__text-image {
      position: absolute;
      top: 50%;
      left: 50%;
      opacity: .1;
      z-index: -1;
      transform: translate(-50%, -50%);
    }
  }
}
</style>